import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/partBcg.svg")